import React, { Fragment, useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import usePermissons from "hooks/usePermissons";
import UseTitle from "hooks/useTitle";

import Users from "../Users";
import Header from "widgets/Header";
import AuthorizedIssuedVouchers from "../../facturacion/AuthorizedIssuedVouchers";
import NoAuthorizedIssuedVouchers from "../../facturacion/NoAuthorizedIssuedVouchers";
import PendingVouchers from "../../facturacion/PendingVouchers";
import HomeContent from "./Content";
import Costumers from "../Clients";
import SubscriptionKey from "../subscriptionKey";
import Partners from "../partners";
import AdmPartners from "../admPartners";
import ProductsService from "../productsServices";
import VoucherCancel from "../../facturacion/CancelVouchers";
import Providers from "../providers";
import Secuencial from "../secuencial";
import AsignacionSecuencial from "../asignacionSecuencial";
import Invoice from "../../facturacion/Vouchers/invoices";
import CompanyData from "../UserAccount/CompanyData";
import ChangePass from "../UserAccount/Forms/ChangePass";
import CreditNote from "../../facturacion/Vouchers/CreditNote";
import Assitence from "../Assistance";
import Informacion from "../Information";
import AlertTimeOut from "./AlertTimeOut";
import PerchaseSettlement from "views/facturacion/Vouchers/perchaseSettlement";
import Retention from "views/facturacion/Vouchers/Retention";
import DebitNote from "../../facturacion/Vouchers/DebitNote";
import ReferralGhide from "views/facturacion/Vouchers/referralGhide";
import NoPrerequisities from "views/facturacion/NoPrerequisites";
import VoucherReportIssued from "views/facturacion/Reports/VoucherReportIssued";
import VoucherReportIssuedPartner from "../comprobantesPorEmpresa/VoucherReportIssuedPartner";
import VoucherReportStatePacGgi from "views/facturacion/Reports/VoucherReportStatePacGgi";
import SalesReport from "views/facturacion/Reports/SalesReport";
import VoucherReportReceived from "views/facturacion/Reports/VoucherReportReceived";
import UploadVoucher from "views/facturacion/Vouchers/Add/UploadVoucher";
import VoucherReceived from "views/facturacion/AuthorizedReceived/index";
import VoucherReportUnauthorized from "views/facturacion/Reports/VoucherReportUnauthorized";
import VoucherReportCancelled from "views/facturacion/Reports/VoucherReportCancelled";
import VoucherReportAuthorizedTotal from "views/facturacion/Reports/VoucherReportAuthorizedTotal";
import VoucherReportAuthorizedForItem from "views/facturacion/Reports/VoucherReportAuthorizedForItem";
import BuyPackage from "../buyPackage";
import UploadVoucherPay from "../buyPackage/components/UploadVoucherPay";
import Company from "../company";
import Payments from "../payments";
import HomeVouchers from "views/facturacion/HomeVouchers";
import {
  getTipoDocumento,
  tipoDocumento,
} from "views/facturacion/Forms/typeVoucher";
import EventAnnulation from "views/facturacion/Events/EventAnulation";
import MassiveRucsQuery from "views/facturacion/Inquiries/MassiveRucsQuery";
import UploadFileExcel from "views/facturacion/HomeVouchers/UploadFileExcel";

const Home = () => {
  const actualContent = useSelector(
    (state) => state.resources.selectedResource
  );
  const dispatch = useDispatch();
  const { updatePermissons } = usePermissons(useSelector, dispatch);

  const updateContent = () => {
    if (typeof actualContent === "undefined" || actualContent === null) {
      UseTitle({ title: "Inicio" });
      return <HomeContent />;
    }
    UseTitle({ title: actualContent.titleTab });

    switch (actualContent.id) {
      case "INI":
        return <HomeContent />;
      case "INI":
        return <HomeContent />;
      case "CLI":
        return <Costumers />;
      case "SUS":
        return <SubscriptionKey />;
      case "PAR":
        return <Partners />;
      case "ADP":
        return <AdmPartners />;
      case "ANU":
        return <VoucherCancel />;
      case "CSE":
        return <Secuencial />;
      case "PRO":
        return <ProductsService />;
      case "USU":
        return <Users />;
      case "AUT":
        return <AuthorizedIssuedVouchers />;
      case "NAU":
        return <NoAuthorizedIssuedVouchers />;
      case "CRA":
        return <VoucherReceived />;
      case "PEN":
        return <PendingVouchers />;
      case "PRV":
        return <Providers />;
      case "ASE":
        return <AsignacionSecuencial />;
      // case "FAC":
      //   return <Invoice />;
      case "FOP": //factura operacion interna
        return <Invoice iDoc={getTipoDocumento("FOP")} />;
      case "FEX": //factura exportacion
        return <Invoice iDoc={getTipoDocumento("FEX")} />;
      case "FIM": //factura importacion
        return <Invoice iDoc={getTipoDocumento("FIM")} />;
      case "FZF": //factura zona franca
        return <Invoice iDoc={getTipoDocumento("FZF")} />;
      case "NDG": //nota de debito generica
        return <Invoice iDoc={getTipoDocumento("NDG")} />;
      case "NDR": //nota de debito referente a una o varias FE
        return <Invoice iDoc={getTipoDocumento("NDR")} />;
      case "NCG": //nota de credito generica
        return <Invoice iDoc={getTipoDocumento("NCG")} />;
      case "NCR": //nota de credito referente a una o varias FE
        return <Invoice iDoc={getTipoDocumento("NCR")} />;
      case "REE": //REEMBOLSO
        return <Invoice iDoc={getTipoDocumento("REE")} />;
      case "FOE": //REEMBOLSO
        return <Invoice iDoc={getTipoDocumento("FOE")} />;
      case "FUE":
        return <UploadFileExcel></UploadFileExcel>;
      case "EAN": //REEMBOLSO
        return <EventAnnulation></EventAnnulation>;
      case "CMR":
        return <MassiveRucsQuery></MassiveRucsQuery>;

      case "AGC":
        return <HomeVouchers />;
      // case "GUI":
      //   return <ReferralGhide />;
      case "CAC":
        return <UploadVoucher />;
      // case "CRE":
      //   return <CreditNote />;
      // case "DEB":
      //   return <DebitNote />;
      // case "RET":
      //   return <Retention />;
      // case "LIQ":
      //   return <PerchaseSettlement />;
      case "RCE":
        return <VoucherReportIssued />;
      case "RCR":
        return <VoucherReportReceived />;
      case "CPD":
        return <VoucherReportStatePacGgi />;
      case "RIV":
        return <SalesReport />;
      case "RFR":
        return <VoucherReportUnauthorized />;
      case "RFA":
        return <VoucherReportCancelled />;
      case "RED":
        return <VoucherReportAuthorizedForItem />;
      case "RET":
        return <VoucherReportAuthorizedTotal />;
      case "DCE":
        return <VoucherReportIssuedPartner />;
      case "AEM":
        return <Company />;
      case "APQ":
        return <Payments />;
      case "IEM":
        return <CompanyData />;
      case "CCO":
        return <ChangePass />;
      case -1:
        return <Assitence />;
      case -2:
        return <Informacion />;
      case -4:
        return <NoPrerequisities />;
      case -5:
        return <BuyPackage />;
      case -6:
        return <UploadVoucherPay />;
      default:
        return <HomeContent />;
    }
  };

  const buildTitle = () => {
    if (typeof actualContent === "undefined" || actualContent === null) {
      return "Inicio";
    } else {
      return actualContent.titlePage;
    }
  };

  useEffect(() => {
    updatePermissons();
  }, []);

  return (
    <Fragment>
      <Header title={buildTitle()} />
      <main>
        <AlertTimeOut percentageWarnigTimeOut={25} />
        {updateContent()}
      </main>
    </Fragment>
  );
};

export default Home;
